import React from 'react';
import { Tag } from 'antd';
import { defaultRoles, defaultRolesDisplayName } from 'constants/RBACConstants';

export const removeRoleFromDefaultRole = (role) => defaultRoles.indexOf(role) !== -1 ? defaultRolesDisplayName[role] : role;

export const checkForOutOfBox = (role) => {
    if (role.outOfBox || defaultRolesDisplayName[role.role] ) {
        return defaultRolesDisplayName[role.role] ?
            <>{defaultRolesDisplayName[role.role]} <Tag className="danger">Out of the box</Tag></> : <>{role.role} <Tag className="danger">Out of the box</Tag></>
    }else{
        return <>{role.role} <Tag className="success">Custom</Tag></>
    }
};